import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/9dXdeKBsDjyG8PNsfR5963/ChatGPT-Image-28-jun-2026_-08_31_56-p.m..webp';
export function FinalCTA() {
  return <section className="py-16 px-4 sm:px-6 bg-brand-navy text-white text-center relative overflow-hidden" data-id="element-48">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-49" />

      <div className="relative z-10" data-id="element-50">
        <p className="text-xs font-black text-brand-gold uppercase tracking-widest mb-5" data-id="element-51">
          ONE LAST CHANCE
        </p>

        <p className="text-sm sm:text-base font-medium mb-10 leading-relaxed max-w-2xl mx-auto text-white/90" data-id="element-52">
          Your clients deserve more than sessions planned at the last minute due
          to a lack of time. Stop spending hours creating forms, exercise
          sheets, and educational materials every week. Stop second-guessing the
          order and structure of your clinical organization. Stop wasting
          valuable time searching through hundreds of unorganized files.
          <span className="font-bold text-white block mt-5" data-id="element-53">
            Give every client a professional, structured, and high-value
            therapeutic experience. Give yourself the professional clinical
            system you wish you had from your very first patient.
          </span>
        </p>

        <div className="bg-white/5 border border-brand-gold/30 rounded-2xl p-6 mb-10 shadow-lg max-w-sm mx-auto backdrop-blur-sm" data-id="element-54">
          <p className="text-xs sm:text-sm font-bold text-brand-gold mb-3 uppercase tracking-wide" data-id="element-55">
            🩺 PSYCHOLOGIST PRO™
            <br data-id="element-56" />
            Complete 6-in-1 Clinical Resource System + 5 Premium Bonuses
          </p>
          <p className="text-base line-through text-white/50 mb-2" data-id="element-57">
            Regular Price: $97
          </p>
          <p className="text-5xl font-heading font-black text-white leading-none" data-id="element-58">
            Today Only: $27 USD
          </p>
        </div>

        <a href="#pricing" className="block cursor-pointer mb-10" data-id="element-59">
          <img src={PRODUCT_IMG} alt="Psychologist Pro 6-in-1 Box Set" className="w-full max-w-[320px] mx-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-60" />
        </a>

        <div className="mb-8 max-w-md mx-auto" data-id="element-61">
          <CTAButton data-id="element-62">🚀 YES! I WANT MY PSYCHOLOGIST PRO™ SYSTEM</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6 text-[10px] sm:text-xs font-bold text-white/80" data-id="element-63">
          <div className="flex items-center gap-1.5" data-id="element-64">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-65" />
            <span data-id="element-66">Immediate Access • Delivered Instantly by Email</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-67">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-68" />
            <span data-id="element-69">4.9/5 — Verified Professional Reviews</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-70">
            <Shield className="w-4 h-4 text-brand-sage" data-id="element-71" />
            <span data-id="element-72">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}